import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// If the server has a new build (different main.*.js), reload so user gets latest app.
// This fixes "old cached app first, then updates" when index.html or JS was cached.
function checkForNewBuild() {
  if (process.env.NODE_ENV !== 'production') return;
  const currentScript = document.querySelector('script[src*="/static/js/main."]');
  const currentSrc = currentScript?.getAttribute('src') || '';
  if (!currentSrc) return;
  const origin = window.location.origin;
  const cacheBust = `?v=${Date.now()}`;
  fetch(`${origin}/index.html${cacheBust}`, { cache: 'no-store' })
    .then((r) => r.text())
    .then((html) => {
      const match = html.match(/src=["']?(\/static\/js\/main\.[^"'\s]+\.js)/);
      const latestMain = match ? match[1] : '';
      if (latestMain && currentSrc.indexOf('/static/js/') !== -1 && latestMain !== currentSrc) {
        window.location.reload();
      }
    })
    .catch(() => {});
}
setTimeout(checkForNewBuild, 1500);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
